import { IntlShape } from "react-intl";
import { PaymentScheduleItem } from "../components/paymentSchedule/paymentSchedule";
import { getOrdinalSuffix } from "./getFormattedMonthlyPaymentDate";
import {
  PaymentPlanDetailItem,
  InstallmentVisualStatus,
  PaymentPlanInstallmentStatus,
  BillingPaymentPlanStatus,
} from "../models/apiControllerModel";
import { convertBalance } from "./convertBalance";

export function transformInstallments(
  paymentPlanItem: PaymentPlanDetailItem | null,
  intl: IntlShape
): PaymentScheduleItem[] {
  if (!paymentPlanItem || !paymentPlanItem.installments) return [];

  return paymentPlanItem.installments.map((item) => {
    const date = new Date(item.dueDate);

    let installmentStatus: InstallmentVisualStatus;

    if (
      paymentPlanItem.status === BillingPaymentPlanStatus.CANCELLED &&
      item.status === PaymentPlanInstallmentStatus.FAILED
    ) {
      installmentStatus = InstallmentVisualStatus.CANCELLED;
    } else if (paymentPlanItem.status === BillingPaymentPlanStatus.COMPLETED) {
      installmentStatus = InstallmentVisualStatus.PAID;
    } else if (item.index < paymentPlanItem.currentInstallmentIndex) {
      installmentStatus = InstallmentVisualStatus.PAID;
    } else if (item.index === paymentPlanItem.currentInstallmentIndex) {
      installmentStatus = InstallmentVisualStatus.CURRENT;
    } else {
      installmentStatus = InstallmentVisualStatus.UP_COMING;
    }

    return {
      label: getOrdinalSuffix(item.index, intl),
      date: intl.formatDate(date, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
      amount: convertBalance(item.amount, true, paymentPlanItem.currency),
      installmentStatus,
      status: item.status,
    };
  });
}
